import React from "react";
import { Row, Col, Form, Modal, Button } from "react-bootstrap";

const CreateRoleModal = (props) => {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          className="ms-auto"
          id="contained-modal-title-vcenter"
        >
          Create Role
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <Form>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>Role</Form.Label>
            <Form.Control type="text" placeholder="Admin" autoFocus />
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
            <Form.Label>Role Description</Form.Label>
            <Form.Control as="textarea" rows={3} style={{ height: "100px" }} />
          </Form.Group>
        </Form>
        <Row className="mt-3 d-flex justify-content-center">
          <Col xl={4} lg={6} className="mb-2 mb-lg-0">
            <Button className="submit-btn border-0">Create</Button>
          </Col>
          <Col xl={4} lg={6}>
            <Button className="cancel-btn border-0" onClick={props.onHide}>Cancel</Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default CreateRoleModal;
